import { IconButton } from '@mui/material';
import { Grid } from '@vy/ui-design-system';
import { getSelectorAttribute, vyTableSelectors } from '@vy/app-selectors';

type VyTableColumnSettingsButtonProps = {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

export const VyTableColumnSettingsButton: React.FC<VyTableColumnSettingsButtonProps> = ({ onClick }) => {
  return (
    <IconButton
      {...getSelectorAttribute(vyTableSelectors.columnSettings)}
      onClick={onClick}
      sx={{
        padding: '9px',
        backgroundColor: '#F5F6FA',
        borderRadius: '4px',
        height: '40px',
        width: '40px',
        '&:hover': {
          backgroundColor: '#E8EBF2',
        },
      }}
    >
      <Grid />
    </IconButton>
  );
};
